/*global _satellite */

import { SearchResultsModel } from 'srp/models/search_results';

import { searchResultTotalCount } from "srp/views/search-results/variables";
MOVE.SRP.SearchResults = (function (SRP) {
  var propertiesController = "properties",
      newCommunitiesController = "new_communities",
      recentlySoldController = "recently_sold",
      newConstructionController = "new_construction",
      foreclosuresController = "foreclosures",
      apartmentsController = "apartments",
      homesForRentController = "homes_for_rent",
      action = "show",
      onReady,
      reInitJs,
      getModel,
      monitorDom,
      savePropertyLinks;

  var init = function (options) {
    showQVOverlay();
    var viewPort = MOVE.Helper.detectViewPort();
    if ($.inArray(viewPort,['x-small', 'xx-small']) === 0) {
      $(window).scrollTop(50); // temp fix for letting user opportunity to scroll upwards for pagination
    }
    var data = (options || {}).data || MOVE.DataStore.getData('searchResults');
    // find the initial viewport on radius search
    newRadiusWithCounty(data);
    SRP.model = new SearchResultsModel(options || {data: data});
    onReady();
  };

  /*
    Existence of `MOVE_DATA.quickview` indicates that a quickview modal
    was opened. Therefore, on page load we need to display the quickview
    overlay.
  */
  var showQVOverlay = function() {
    if (MOVE_DATA.quickview) {
      $('#qv-wrap').addClass('qv-refresh-load');
    }
  };

  var newRadiusWithCounty = function newRadiusWithCounty(data){
    if( MOVE_DATA.radius_previous_viewport !== null && MOVE_DATA.radius_previous_viewport !== undefined ){
      data.position = MOVE_DATA.radius_previous_viewport;
    }
  };

  var loadPage = function (controllerName){
    let pageName = $("." + controllerName + '.' + action);
    if (pageName.length === 1 ) {
      pageName.ready(
        monitorDom
      );
    }
  };

  getModel = function() {
    return SRP.model;
  };

  onReady = function onReady() {
    loadPage(propertiesController);
    loadPage(newCommunitiesController);
    loadPage(recentlySoldController);
    loadPage(newConstructionController);
    loadPage(foreclosuresController);
    loadPage(apartmentsController);
    loadPage(homesForRentController);
  };

  monitorDom = function monitorDom() {

    savePropertyLinks();
    unveilLoadImages();
    MOVE.Helper.pageLinking();
  };

  reInitJs = function reInitJs() {
    savePropertyLinks();
    unveilLoadImages();
    MOVE.SRP.PerPageCount.init();
    // pagination js is now rebound after the "search::updated" event
  };

  savePropertyLinks = function () {
    var srpLinks = [];
    $('#srp-list .js-component_property-card').each(function () {
      if ($(this).data('url')){
        srpLinks.push($(this).data('url'));  //Save the property URL
      }
    });
    if (srpLinks.length > 0) {
      var criteria = MOVE.Helper.getSearchCriteriaFromCookie() || {};
      MOVE.Helper.setPropertyLinksToStorage(srpLinks, searchResultTotalCount, criteria.pg || 1);
    }
  };

  var unveilLoadImages = function () {
    MOVE.DOMHelper.unveilLoadImages('img:not(.js-srp-listing-photos)', {}, $(".srp-card-wrapper"));
    MOVE.DOMHelper.unveilLoadImages('img.js-srp-listing-photos', { scrollContainer: $('.srp-card-wrapper') }, $('.srp-card-wrapper'), unveilCallback);
  };

  var unveilCallback = function() {
    $(this).one('load', function() {
      if ($(this).hasClass('streetview-photo')) {
        let $photo = $(this),
            src = $photo.data('src'),
            info = src.match(/(.*)(\?.*&signature=).*&metadata=(.*)/) || [],
            url = info[1],
            params = info[2],
            signature = info[3];

        if (url && params && signature) {
          $.ajax({
            url:     url + '/metadata' + params + signature,
            method:  'GET',
            success: function(response) {
              if (response.status.toLowerCase() !== 'ok') {
                let fallback = $photo.data('fallback');
                $photo.attr('src', fallback).attr('data-src', fallback);
              }
            }
          });
        }
        $photo.removeClass('streetview-photo');
      }
    });
  };

  SRP.SearchResults = {
    init: init,
    reInitJs: reInitJs,
    unveilLoadImages: unveilLoadImages,
    getModel: getModel
  };
  return SRP.SearchResults;
}(MOVE.SRP || {}));



// WEBPACK FOOTER //
// ./srp/controllers/search_results.js